import React from 'react';

import { SingleSelect } from '@fortress-technology-solutions/fortress-component-library/Molecules';
import styled from 'styled-components';

type Props = {
  name: string,
  value: string,
  onChange: Function,
  city: string,
  state: string,
};

const StyledSingleSelect = styled(SingleSelect)``;

const nycOption = {
  value: '25-60',
  text: '25-60 (N.Y.C. Only)',
  disabled: true,
};

const setAsideOptions = [
  {
    value: '20-50',
    text: '20-50',
    disabled: false,
  },
  {
    value: '40-60',
    text: '40-60',
    disabled: false,
  },
  {
    value: 'Average Income',
    text: 'Average Income',
    disabled: false,
  },
  nycOption,
];

export const MinimumSetAside = ({
  name,
  value,
  onChange,
  city,
  state,
}: Props) => {
  nycOption.disabled = !(
    state === 'US-NY' && city?.toLowerCase()?.startsWith('new york')
  );

  return (
    <StyledSingleSelect
      name={name}
      options={setAsideOptions}
      size="small"
      value={value}
      onChange={onChange}
      // weird that this explicitly has to be set to null to not generate an
      // empty element
      helperText={null}
    />
  );
};
